module.exports = __webpack_public_path__ + "img/indochine_central.0b6a9331.jpg";